import BasketModelBase from '../_generated/modelBases/basket-model-base';

export default class BasketModel extends BasketModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
